import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import { parsePoliciesThroughputIgnoringSpeeds } from "./api";
import { safeStr, getBqnIdCmdPart } from "common/api";
import View from "common/View";
import Help from "./Help";

const doSubscribersShareRetrieval = (hours = 72, type = "rate", mode, bqnId) =>
  ifCl.run(`show statistics policy ${safeStr(type)} speed lines ${hours * 12}${getBqnIdCmdPart(mode, bqnId)}`);

const retrieval = ({ hours, policyType, mode, bqnId }) =>
  doSubscribersShareRetrieval(hours, policyType, mode, bqnId)
    .then(parsePoliciesThroughputIgnoringSpeeds)
    .catch((error) => console.error(error) || error)

const enabled = {
  policyType: true,
  hours: true,
  directions: false,
  categories: false,
  target: false,
  output: false,
  filter: false,
};

const PerPolicySubscribersView = () => {
  const actions = useContext(ActionsContext);
  return (
    <View title="Subscribers per policy by time" Help={Help}>
      <Report
        from="timeline"
        itemsFrom="policies"
        itemsValueFrom="subscribers"
        yAxisUnits="Subscribers"
        yAxisPrecision={0}
        provider={retrieval}
        actions={actions}
        enabled={enabled}
      />
    </View>
  );
};

export default PerPolicySubscribersView;
